import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import Icon, { Icons } from '../Icon/Icon';

import './IconBox.scss';

const ICON_LABEL_SIZE_RELATIVE = 0.5;

const IconBox = ({ className = '', icon = null, iconLabel = null, size = 48 }) => {
	const iconNode = typeof icon === 'string' ? <Icon type={Icons[icon]} width={size} height={size} /> : icon;
	const iconLabelNode =
		typeof iconLabel === 'string' ? (
			<Icon type={Icons[iconLabel]} width={size * ICON_LABEL_SIZE_RELATIVE} height={size * ICON_LABEL_SIZE_RELATIVE} />
		) : (
			iconLabel
		);

	return (
		<div className={classNames('IconBox', className)}>
			{iconNode}
			{iconLabelNode && <div className='IconBox__icon-label'>{iconLabelNode}</div>}
		</div>
	);
};

IconBox.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	size: PropTypes.number,
};

export default IconBox;
